import Vue from 'vue'

//only for selections and callbacks
let currentCouponCode = '';

export function setCurrentCouponCode(v){
    currentCouponCode = v;
}
export function getCurrentCouponCode(v){
    return currentCouponCode;
}

export function isCouponRedeemed(coupon, fuid) {
    let redeemed = false;
    // let cp = store.getters.getCouponByCode(couponCode);
    if (!coupon) {
        redeemed = true;
    } else {
        if (fuid) {
            if (coupon.redeemer) {
                let red = coupon.redeemer.find(r => r.fuid === fuid);
                if (red) {
                    redeemed = true;
                }
            }
        }
    }

    if (redeemed || coupon.redeemed) {
        //already redeemed, so lets remove it
        return true;
    } else {
        return false;
    }
}

export function isValidOnDay(coupon, dayNum){
    if (coupon.days) {
        // let day = '' + getDayOfWeek(new Date());
        if (!coupon.days.includes(''+dayNum)) {
            return false;
        }
    }
    return true;
}

export function redemptionOlderThan3Hours(couponCode){
    let redeemedNow = !!getCouponNowRedeemedAt(couponCode);
    if (!redeemedNow) {
        return false;
    }

    let redeemedNowAt = getCouponNowRedeemedAt(couponCode);
    // console.log('redeemedNowAt = '+redeemedNowAt);
    if (redeemedNowAt) {
        if (Date.now() - redeemedNowAt > (3 * 60 * 60 * 1000)) {
            return true;
        }
    }

    return false;
}

export function getCouponNowRedeemedAt(couponCode) {
    if (!couponCode) {
        return null;
    }
    let cn = Vue.ls.get('couponsNow', false);//contains an array of {'at' and 'couponCode'}
    let redeemedAt = null;
    if (cn) {
        let cc = '' + couponCode;
        let _now = Date.now();
        let arr = cn;//array of objects
        let newArr = [];
        let replace = false;
        for (let r of arr) {
            // at, couponCode
            if (r.couponCode === cc) {
                redeemedAt = r.at;
            }

            //remove the entry if it is older than 3 months
            if (_now - r.at > (3 * 30 * 24 * 60 * 60 * 1000)) {
                replace = true;
            } else {
                newArr.push(r)
            }
        }
        if (replace) {
            Vue.ls.set('couponsNow', newArr);
        }
    }
    return redeemedAt;
}

export function isCouponValidForFiliale(coupon, filialnummer) {
    //filter by Lieblingsfiliale and array of filialnummern validStores
    if (coupon.validStores && filialnummer) {
        if (!coupon.validStores.includes(filialnummer)) {
            return false;
        }
    }
    return true;
}

export function filteredCoupons(coupons, scannedCode, fuid, uid,filialnummer) {
    return coupons.filter(c => {

        //filter by Lieblingsfiliale and array of filialnummern validStores
        if (!isCouponValidForFiliale(c, filialnummer)) {
            return false;
        }

        let visib = c.visibility;

        if (visib !== 'public' && visib !== 'individual' && visib !== 'private') {
            //unknown visibility or type error
            return false;
        }

        if (visib === 'individual') {
            if(c.redeemed){
                return false;
            }
            if (c.fuid) {
                return c.fuid === fuid;
            } else if (c.uid) {
                return c.uid === uid
            } else {
                return false;
            }
        }
        if (visib === 'private') {
            let codes = Vue.ls.get('scannedCodes', false);//array of strings
            if (codes) {
                if (codes.includes(c.couponCode)) {
                    //already scanned
                    return true;
                    // }else{
                    //     if(scannedCode){
                    //         codes.push(scannedCode);
                    //         localStorage.setItem('scannedCodes', JSON.stringify(codes));
                    //     }
                }
                // }else{
                //     if(scannedCode){
                //         localStorage.setItem('scannedCodes', JSON.stringify([scannedCode]));
                //     }
            }

            return scannedCode === c.couponCode;
        }

        //public
        return true;
    });
}